import { Component } from 'react';
import { withRouter } from 'react-router-dom';

/**
 * RouteChangeHandler
 * Forces app to re-render on every route change
 * This fixes the issue where URL changes but page doesn't update
 */
class RouteChangeHandler extends Component {
    componentDidUpdate(prevProps) {
        if (this.props.location.pathname !== prevProps.location.pathname) {
            // Force window to acknowledge route change
            window.dispatchEvent(new Event('route-changed'));
            
            // Scroll to top on route change
            window.scrollTo(0, 0);
            
            console.log('Route changed:', prevProps.location.pathname, '→', this.props.location.pathname);
        }
    }

    render() {
        return this.props.children;
    }
}

export default withRouter(RouteChangeHandler);

